import { FC, ComponentProps } from 'react';
import { useSelector } from 'react-redux';
import { Asset, Box, Loader } from '@altermaind/web/ui';
import { getModeTheme } from '@/_shared/styles/state/selectors';

type Props = {
  mainWrapperProps?: ComponentProps<typeof Box>;
  loaderContainerProps?: ComponentProps<typeof Box>;
};

export const LoadingPage: FC<Props> = ({ mainWrapperProps = {}, loaderContainerProps = {} }) => {
  const mode = useSelector(getModeTheme());

  return (
    <Box
      bg='primary/background'
      height='100vh'
      width='100vw'
      flexDirection='column'
      display='flex'
      alignItems='center'
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...mainWrapperProps}
    >
      <Box
        minHeight='100vh'
        display='flex'
        flex='0 0 auto'
        alignItems='center'
        justifyContent='center'
        flexDirection='column'
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...loaderContainerProps}
      >
        <Asset
          mb='xl'
          domain='images'
          name={mode === 'light' ? 'logoLight' : 'logoDark'}
          width='150'
        />
        <Loader color='primary/text' size='50px' />
      </Box>
    </Box>
  );
};
